export const uk = {
    groups: 'В группах',
    name: 'Название',
    preview: 'Предпросмотр'
};
